$(document).ready(function(){ 
	
	$('#nav ul').supersubs({
			minWidth:    12,   // minimum width of submenus in em units
			maxWidth:    27,   // maximum width of submenus in em units
			extraWidth:  1     // extra width can ensure lines don't sometimes turn over
	}).superfish(); 

	$('#nav ul, #collection-tags ul' ).tinyNav({
        active: 'current',
    });
    
    $("#slider").responsiveSlides({
        auto: true,
        pager: false,
        nav: true,
        speed: 500,
        maxwidth: 940,
        namespace: "centered-btns"
    });

    $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    }); 

    $('.scrollup').click(function(){
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });
    
    $('#thumbs').delegate('img','click', function(){
		$('#large-image').attr('src',$(this).attr('src'));
		$('#featured').attr('href',$(this).attr('src'));
	});
	
	$('ul.tabs').each(function(){

	    var $active, $content, $links = $(this).find('a');
	    $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
	    $active.addClass('active');
	    $content = $($active.attr('href'));
	
	    // Hide the remaining content
	    $links.not($active).each(function () {
	        $($(this).attr('href')).hide();
	    });
	
	    $(this).on('click', 'a', function(e){
	        // Make the old tab inactive.
	        $active.removeClass('active');
	        $content.hide();
	
	        $active = $(this);
	        $content = $($(this).attr('href'));
	
	        // Make the tab active.
	        $active.addClass('active');
	        $content.show();
	
	        // Prevent the anchor's default click action
	        e.preventDefault();
	    });
	});

});

















